import { render, staticRenderFns } from "./NativeAdsProperties.vue?vue&type=template&id=0cc1ef08&scoped=true"
import script from "./NativeAdsProperties.vue?vue&type=script&lang=js"
export * from "./NativeAdsProperties.vue?vue&type=script&lang=js"
import style0 from "./NativeAdsProperties.vue?vue&type=style&index=0&id=0cc1ef08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc1ef08",
  null
  
)

export default component.exports